import { Component, inject, signal } from '@angular/core';
import {
  MessageLevels,
  HngMessageNotifierService,
  NotifyEvent,
} from '@hidat/ng-common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';

/**
 * A very simple tailwind based notifier service
 * Simply monitors the message notifier bus and displays the given message inline
 */
@Component({
  selector: 'pv2-notify-component',
  templateUrl: 'player-notify.component.html',
  styleUrl: 'player-notify.component.scss',
  standalone: true,
  imports: [NgClass],
})
export class PlayerNotifyComponent {
  msgNotifier = inject(HngMessageNotifierService);

  protected message = signal<string | undefined | null>(null);
  protected msgVisible = signal(false);
  protected showCloseButton = signal(false);
  protected msgClasses = signal<string[]>([]);
  protected msgTimer: ReturnType<typeof setTimeout> | undefined;

  constructor() {
    this.msgNotifier.messageSource
      .pipe(takeUntilDestroyed())
      .subscribe((msg) => this.processMessage(msg));
  }

  protected processMessage(msg: NotifyEvent) {
    const klasses: string[] = [];
    let timeoutSeconds = 5;
    let showCloseButton = false;

    switch (msg.level) {
      case MessageLevels.INFO:
        klasses.push('bg-zinc-200/85');
        klasses.push('text-gray-950');
        break;

      case MessageLevels.WARN:
        klasses.push('bg-amber-300/85');
        klasses.push('text-gray-950');
        timeoutSeconds = 10;
        break;

      case MessageLevels.ERROR:
        klasses.push('bg-rose-500/85');
        klasses.push('text-white');
        showCloseButton = true;
        timeoutSeconds = 30;
        break;
    }
    this.message.set(msg.message);
    this.msgClasses.set(klasses);
    if (timeoutSeconds) {
      this.showCloseButton.set(true);
      this.msgVisible.set(true);
      this.msgTimer = setTimeout(() => {
        this.msgVisible.set(false);
        this.msgTimer = undefined;
      }, timeoutSeconds * 1000);
    } else {
      this.msgVisible.set(true);
    }
  }

  protected closeMessage = () => {
    this.msgVisible.set(false);
    if (this.msgTimer) {
      clearInterval(this.msgTimer);
      this.msgTimer = undefined;
    }
  };
}
